import {Button, Flex, Image, Space, Tag, Typography} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPencil, faTrash} from "@fortawesome/free-solid-svg-icons";
import Markdown from "react-markdown";
import React, {createRef, Fragment, ReactNode, useEffect} from "react";
import {IEntity} from "../../feature/project/story";
import {editorRoles, WithUserPermission} from "./WithUserPermission";

export const EntityDetails = (props: {
    entity: IEntity,
    onEditClick: () => void,
    onDeleteClick: () => void,
    extra?: ReactNode,
    simple?: boolean
}) => {
    const ref = createRef<HTMLDivElement>();
    const [hasTags, setHasTags] = React.useState(false);

    useEffect(() => {
        ref.current?.scrollTo(0, 0)
    }, [props.entity.id])

    useEffect(() => {
        setHasTags(props.entity.tags?.length !== undefined && props.entity.tags?.length > 0)
    }, [props.entity])

    return (
        <Flex style={{paddingLeft: '20px', height: "100%"}} vertical={true} gap={16}>
            <WithUserPermission roles={editorRoles}>
                <Flex justify={'space-between'} align={'center'}>
                    {props.extra ? props.extra : <div></div>}
                    <Space>
                        <Button onClick={props.onDeleteClick}><FontAwesomeIcon icon={faTrash}/></Button>
                        <Button onClick={props.onEditClick}><FontAwesomeIcon icon={faPencil}/></Button>
                    </Space>

                </Flex>
            </WithUserPermission>
            <div style={{
                overflowY: 'auto', scrollbarWidth: "none",
                overflowX: 'visible',
                height: '100%',
                width: '100%'
            }} ref={ref}>
                <Space direction={'vertical'} style={{width: '100%'}}>
                    {!props.simple ?
                        <Image className={'big-cover'}
                               width={'100%'}
                               alt={props.entity.title}
                               src={props.entity.cover ? props.entity.cover : '/images/placeholder.png'}
                               style={{borderRadius: 8, objectFit: 'cover', aspectRatio: 1}}
                        /> : ''}
                    <Typography style={{fontWeight: 700, fontSize: 18}}>{props.entity.title}</Typography>
                    <div>
                        <Markdown className={"markdown-text"}>{props.entity.description}</Markdown>
                    </div>
                    {hasTags ? <>
                        <Typography style={{fontWeight: 700}}>Tags</Typography>
                        <Flex style={{gap: '8px 0'}} wrap={'wrap'}>{
                            props.entity.tags?.map(tag => <Tag key={tag.id}>{tag.title}</Tag>)
                        }
                        </Flex>
                    </> : ''}
                </Space>
            </div>
        </Flex>
    )
}